// Too much files to change
import { Component, ComponentChildren } from 'preact'
import ConfigurationSectionLabel from './ConfigurationSectionLabel'
// eslint-disable-next-line import/no-internal-modules
import { common } from '../../../../preact-components/common'
// eslint-disable-next-line import/no-internal-modules
import {
  WidgetContainerConfig
  // eslint-disable-next-line import/no-internal-modules
} from '../../../../preact-components/widget-container'
// eslint-disable-next-line import/no-internal-modules
import TextField from '../../../../preact-components/design-system-components/text-field'
import classNames from 'classnames'
import {
  ColorPickerField,
  BackgroundDisplayField,
  DescriptionColorDisplayField,
  TitleColorDisplayField
} from './fields'

interface WidgetContainerConfigFieldsProps {
  config: WidgetContainerConfig
  nested: boolean
  widgetName: string
  showContentSection?: boolean
  children?: ComponentChildren
  onChange: (config: State) => void
  additionalConfigurations?: ComponentChildren
}

interface State extends WidgetContainerConfig {
  enablePicker: boolean
}

const DISPLAY_OPTIONS_SOLID_COLOR = 'solid_color'

export default class WidgetContainerConfigFields extends Component<
  WidgetContainerConfigFieldsProps,
  State
> {
  state = {
    title: this.props.config.title,
    subtitle: this.props.config.subtitle,
    backgroundColor: this.props.config.backgroundColor,
    backgroundColorDisplay: this.props.config.backgroundColorDisplay,
    titleColor: this.props.config.titleColor,
    titleColorDisplay: this.props.config.titleColorDisplay,
    descriptionColor: this.props.config.descriptionColor,
    descriptionColorDisplay: this.props.config.descriptionColorDisplay,
    enablePicker: false
  }

  render() {
    const {
      widgetName,
      showContentSection = true,
      children,
      onChange,
      additionalConfigurations,
      nested
    } = this.props
    const { title, subtitle } = this.state
    // TODO change this module validation to ModulesContext, the issue probably lies on Customization/configurator/orderAnimation PortalProxy class
    const isFeatureFlagOn = common.isModuleActive('subtitleAndBackgroundToWidgets')

    return (
      <div className={classNames(widgetName, 'widget-configurator_tabs-wrapper')}>
        {showContentSection ? (
          <ConfigurationSectionLabel title='Content'>
            <TextField
              isControl
              size='fullWidth'
              className={`${widgetName}-title-input`}
              name='container-widget-title'
              label='Title'
              ariaLabel='title'
              id={`${widgetName}-widget-title`}
              onChange={(title) => {
                this.setState({ title }, () => onChange(this.state))
              }}
              defaultValue={title}
              updateInputValue={title}
            />
            {isFeatureFlagOn && (
              <TextField
                isControl
                size='fullWidth'
                name='container-widget-subtitle'
                label='Subtitle'
                ariaLabel='subtitle'
                id='container-widget-subtitle'
                onChange={(subtitle) => {
                  this.setState({ subtitle }, () => onChange(this.state))
                }}
                defaultValue={subtitle}
                updateInputValue={subtitle}
              />
            )}
            {children}
          </ConfigurationSectionLabel>
        ) : (
          children
        )}
        {additionalConfigurations}
        {isFeatureFlagOn && !nested && (
          <ConfigurationSectionLabel title='Widget style'>
            <BackgroundDisplayField
              value={this.state.backgroundColorDisplay}
              onValueChange={(value) => {
                this.setState({ backgroundColorDisplay: value }, () => onChange(this.state))
              }}
            />
            {this.state.backgroundColorDisplay === DISPLAY_OPTIONS_SOLID_COLOR && (
              <ColorPickerField
                inputId='widget-background-color-picker'
                title='Background custom color'
                defaultValue='#c4c4c4'
                value={this.state.backgroundColor}
                onValueChange={(value) => {
                  this.setState({ backgroundColor: value }, () => onChange(this.state))
                }}
              />
            )}
            {/** This check is temporal, since we introduce these functionality only for the Banner Widget  */}
            {widgetName === 'banner' && (
              <div>
                <TitleColorDisplayField
                  value={this.state.titleColorDisplay}
                  onValueChange={(value) => {
                    this.setState({ titleColorDisplay: value }, () => onChange(this.state))
                  }}
                />
                {this.state.titleColorDisplay === 'solid_color' && (
                  <ColorPickerField
                    inputId='widget-title-color-picker'
                    title='Title custom color'
                    defaultValue='#000000'
                    value={this.state.titleColor}
                    onValueChange={(value) => {
                      this.setState({ titleColor: value }, () => onChange(this.state))
                    }}
                  />
                )}
                <DescriptionColorDisplayField
                  value={this.state.descriptionColorDisplay}
                  onValueChange={(value) => {
                    this.setState({ descriptionColorDisplay: value }, () => onChange(this.state))
                  }}
                />
                {this.state.descriptionColorDisplay === 'solid_color' && (
                  <ColorPickerField
                    inputId='widget-description-color-picker'
                    title='Description custom color'
                    defaultValue='#333333'
                    value={this.state.descriptionColor}
                    onValueChange={(value) => {
                      this.setState({ descriptionColor: value }, () => onChange(this.state))
                    }}
                  />
                )}
              </div>
            )}
          </ConfigurationSectionLabel>
        )}
      </div>
    )
  }
}
